module.exports = __webpack_public_path__ + "img/zxsign7.4c80a716.png";